// src/utils/CleanupTracker.js
export class CleanupTracker {
  constructor() {
    this.timeouts = new Set();
    this.intervals = new Set();
    this.listeners = new Map();
    this.subscriptions = new Set();
    this.animationFrames = new Set();
    this.disposed = false;
  }

  setTimeout(fn, delay) {
    if (this.disposed) return null;
    const id = setTimeout(() => {
      this.timeouts.delete(id);
      if (!this.disposed) fn();
    }, delay);
    this.timeouts.add(id);
    return id;
  }

  addInterval(id) {
    if (!this.disposed) this.intervals.add(id);
    return id;
  }

  addListener(key, cleanup) {
    if (!this.disposed) this.listeners.set(key, cleanup);
  }

  addSubscription(cleanup) {
    if (!this.disposed) this.subscriptions.add(cleanup);
  }

  cleanup() {
    this.disposed = true;
    
    this.timeouts.forEach(id => clearTimeout(id));
    this.timeouts.clear();
    
    this.intervals.forEach(id => clearInterval(id));
    this.intervals.clear();
    
    this.animationFrames.forEach(id => cancelAnimationFrame(id));
    this.animationFrames.clear();
    
    this.listeners.forEach(cleanup => {
      try {
        if (typeof cleanup === 'function') cleanup();
      } catch (e) {
        console.debug('Listener cleanup error:', e);
      }
    });
    this.listeners.clear();
    
    this.subscriptions.forEach(cleanup => {
      try {
        cleanup();
      } catch (e) {
        console.debug('Subscription cleanup error:', e);
      }
    });
    this.subscriptions.clear();
  }
}